import { MenuItem, styled } from '@mui/material'
const StyledMenuItem = styled(MenuItem)`
`

export interface ActionItemProps {
  onClick: () => void
  testId?: string
  children: string
}

export function ActionItem (props: ActionItemProps): JSX.Element {
  return <StyledMenuItem key={props.testId} onClick={props.onClick} data-testid={props.testId} >{props.children}</StyledMenuItem>
}
